import findKey from "lodash/findKey";
import get from "lodash/get";
import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import { ROUTE_ANCHOR } from "../constants";
import PageObject from "./pageObject";
export default class RoutesAndPagesMap {
    constructor() {
        this.add = (key, data) => {
            var _a;
            if (!(data instanceof PageObject))
                throw new Error("Adding data is not a PageObject object");
            if (isNil(this._defaultHash) && (data === null || data === void 0 ? void 0 : data.canBeDefault) && (data === null || data === void 0 ? void 0 : data.self) && !isNil((_a = data === null || data === void 0 ? void 0 : data.self) === null || _a === void 0 ? void 0 : _a.hash)) {
                this._defaultHash = data.self.hash;
            }
            this._items[key] = data;
        };
        this.getDefaultHash = () => this._defaultHash || "";
        this.getDefaultHref = () => `${ROUTE_ANCHOR}${this.getDefaultHash()}`;
        this.get = (key) => this._items[key];
        this.getPageComponent = (key) => get(this.get(key), "PageComponent");
        this.getLocale = (key) => get(this.get(key), "self.locale");
        this.getParents = (key) => get(this.get(key), "parents");
        this.getPath = (key, ...props) => {
            const func = get(this.get(key), "buildPath");
            return isFunction(func) ? func(...props) : undefined;
        };
        this.getByHash = (hash, completeMatch = true) => {
            var _a, _b;
            const hashForSearch = hash || this.getDefaultHash();
            if (isNil(hashForSearch))
                return undefined;
            const key = findKey(this._items, (item) => {
                if (!item.self || isNil(item.self.hash))
                    return false;
                if (completeMatch)
                    return item.self.hash === hashForSearch;
                return ((!item.self.hash && item.self.hash === hashForSearch) ||
                    (item.self.hash && new RegExp(`^${item.self.hash}$`).test(hashForSearch)));
            });
            if (!key)
                return undefined;
            const pageObject = this.get(key);
            if (!pageObject)
                return undefined;
            if (completeMatch)
                return { key, payload: {} };
            return ((_a = pageObject.self) === null || _a === void 0 ? void 0 : _a.hash) !== undefined
                ? { key, payload: (_b = new RegExp(`^${pageObject.self.hash}$`).exec(hashForSearch)) === null || _b === void 0 ? void 0 : _b.groups }
                : undefined;
        };
        this.getWithNoRoute = () => findKey(this._items, (e) => !e.self);
        this._items = {};
        this._defaultHash = null;
    }
}
